<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>早見表出力</h1>
<mat-accordion class="expantion-style">
    <mat-expansion-panel class="sg-search-condition-expansion" [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="title">検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
            <form [formGroup]="tankatableConditionForm">
                <app-sgkc041d-reference-table-search-condition (onClickSearchEvent)="onClickSearch()"
                    [codeConversionMstMap]="codeConversionMstMap" (onClickClearEvent)="onClickClear()"
                    [sgkc026aResponse]="sgkc026aResponse"></app-sgkc041d-reference-table-search-condition>
            </form>
        </div>
    </mat-expansion-panel>
</mat-accordion>
<div *ngIf="showResult && tankatable.length > 0">
    <mat-card class="cur-card">
        <app-sgkc041d-reference-table-search-result [tankatable]="tankatable" (onSelectedEvent)="onSelected($event)"
            id="searchresult"></app-sgkc041d-reference-table-search-result>
    </mat-card>
    <mat-card class="cur-card">
        <app-sgkc041d-reference-table-output-condition [formGroup]="referenceTableForm"
            [codeConversionMstMap]="codeConversionMstMap" (onClickOutputEvent)="onClickOutput()"
            [energyClscode]="energyClscode" [searchTargetYm]="searchTargetYm" id="outputcondition">
        </app-sgkc041d-reference-table-output-condition>
    </mat-card>
</div>